module.exports = __webpack_public_path__ + "static/media/checkin.5e9bba74.svg";